import { Component } from '@angular/core';
import { detectBody } from '../../../app.helpers';
import {SpinnerService} from "../../spinner/spinner.service";

declare var jQuery:any;

@Component({
  selector: 'basic',
  templateUrl: 'basicLayout.template.html',
  host: {
    '(window:resize)': 'onResize()'
  },
})
export class BasicLayoutComponent {

  constructor(private spinnerService: SpinnerService){}
  
  public ngOnInit():any {
    detectBody();
  }

  public onResize(){
    detectBody();
  }

}
